// Layout.js
import Navbar from "./NavBar";

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-black">
      <Navbar />
      <main className="flex-grow">{children}</main>
    </div>
  );
};

export default Layout;